"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRangeItemByDates = exports.createRangeItems = void 0;

var _moment = _interopRequireDefault(require("moment"));

/**
 * Create range items.
 *
 * @param {string} format - Items format.
 * @returns {Array}
 *
 * @example
 * // TODO: Add example.
 */
var createRangeItems = function createRangeItems(format) {
  return [{
    label: 'All Times',
    custom: false,
    empty: true,
    value: {}
  }, {
    label: 'Month to Date',
    custom: false,
    value: {
      from: (0, _moment["default"])().utc().startOf('month').format(format),
      to: (0, _moment["default"])().utc().endOf('day').format(format)
    }
  }, {
    label: 'Year to Date',
    custom: false,
    value: {
      from: (0, _moment["default"])().utc().startOf('year').format(format),
      to: (0, _moment["default"])().utc().endOf('day').format(format)
    }
  }, {
    label: 'Past Week',
    custom: false,
    value: {
      from: (0, _moment["default"])().utc().subtract(1, 'week').startOf('week').format(format),
      to: (0, _moment["default"])().utc().subtract(1, 'week').endOf('week').format(format)
    }
  }, {
    label: 'Past Month',
    custom: false,
    value: {
      from: (0, _moment["default"])().utc().subtract(1, 'months').startOf('month').format(format),
      to: (0, _moment["default"])().utc().subtract(1, 'months').endOf('month').format(format)
    }
  }, {
    label: 'Past Quarter',
    custom: false,
    value: {
      from: (0, _moment["default"])().utc().subtract(3, 'month').startOf('month').format(format),
      to: (0, _moment["default"])().utc().subtract(1, 'month').endOf('month').format(format)
    }
  }, {
    label: 'Past 6 Months',
    custom: false,
    value: {
      from: (0, _moment["default"])().utc().subtract(6, 'month').startOf('month').format(format),
      to: (0, _moment["default"])().utc().subtract(1, 'month').endOf('month').format(format)
    }
  }, {
    label: 'Past Year',
    custom: false,
    value: {
      from: (0, _moment["default"])().utc().subtract(1, 'year').startOf('year').format(format),
      to: (0, _moment["default"])().utc().subtract(1, 'year').endOf('year').format(format)
    }
  }, {
    label: 'Custom Range',
    custom: true,
    value: {
      from: '',
      to: ''
    }
  }];
}; // eslint-disable-next-line require-jsdoc


exports.createRangeItems = createRangeItems;

var getEmptyRangeItem = function getEmptyRangeItem(items) {
  return items.find(function (_ref) {
    var empty = _ref.empty;
    return empty;
  });
}; // eslint-disable-next-line require-jsdoc


var getCustomRangeItem = function getCustomRangeItem(items) {
  return items.find(function (_ref2) {
    var custom = _ref2.custom;
    return custom;
  });
};
/**
 * Get range items for from - to period.
 *
 * @param {string} from - From date.
 * @param {string} to - To date.
 * @param {Array} items - Items format.
 * @returns {Array}
 *
 * @example
 * // TODO: Add example.
 */


var getRangeItemByDates = function getRangeItemByDates(from, to, items) {
  if (!from && !to) {
    return getEmptyRangeItem(items);
  }

  var foundDate = items.find(function (_ref3) {
    var value = _ref3.value;
    return value.from === from && value.to === to;
  });
  return foundDate || getCustomRangeItem(items);
};

exports.getRangeItemByDates = getRangeItemByDates;